import { signedFetch } from './client';

export async function listStreams(storeName: string): Promise<{streams: string[]}> {
  const resp = await signedFetch('GET', `/stores/${storeName}/streams`);
  return resp.data as {streams: string[]};
}

export async function getEvents(storeName: string, stream: string, options?: {
  limit?: number;
  sort?: 'asc' | 'desc';
  filter?: string;
  cursor?: string;
  fields?: string;
  filterField?: string;
  filterValue?: string;
  filterOperation?: string;
}) {
  const params = new URLSearchParams();
  if (stream) params.set('stream', stream);
  if (options?.limit) params.set('limit', String(options.limit));
  if (options?.sort) params.set('sort', options.sort);
  if (options?.filter) params.set('filter', options.filter);
  if (options?.cursor) params.set('cursor', options.cursor);
  if (options?.fields) params.set('fields', options.fields);
  if (options?.filterField) params.set('filterField', options.filterField);
  if (options?.filterValue) params.set('filterValue', options.filterValue);
  if (options?.filterOperation) params.set('filterOperation', options.filterOperation);
  return signedFetch('GET', `/stores/${storeName}/events?${params.toString()}`);
}

export async function getEvent(storeName: string, stream: string, version: number) {
  return signedFetch('GET', `/stores/${storeName}/events/${version}?stream=${encodeURIComponent(stream)}`);
}

export async function putEvent(
  storeName: string,
  key: { stream?: string; keyFields?: Record<string, string> } | string | Record<string, string>,
  data: object,
  metadata?: { eventType?: string; correlationId?: string; causedBy?: string | string[]; schemaVersion?: number },
  expectedVersion?: number
) {
  const body: Record<string, unknown> = { data };

  if (typeof key === 'string') {
    body.stream = key;
  } else if ('stream' in key || 'keyFields' in key) {
    if ((key as { stream?: string }).stream) body.stream = (key as { stream: string }).stream;
    if ((key as { keyFields?: Record<string, string> }).keyFields) body.keyFields = (key as { keyFields: Record<string, string> }).keyFields;
  } else {
    body.keyFields = key;
  }

  if (metadata) body.metadata = metadata;
  if (expectedVersion !== undefined) body.expectedVersion = expectedVersion;
  return signedFetch('POST', `/stores/${storeName}/events`, body);
}
